/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var Marionette = require('backbone.marionette');

var SecCompRegFormView = require('./SecCompRegFormView');
var tmplSecIntCompRegView = require('../templates/SecIntCompRegView.hbs');
var BreadcrumbView = require('common/views/BreadcrumbView');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecIntCompRegView,

  className: 'sec-compliance-registration-view container-fluid',

  ui: {
    headerBar: '.header-bar',
    breadcrumb: '.breadcrumb-container',
    complianceRegistrationForm: '.compliance-registration-form-container'
  },

  behaviors: {
    ReadOnlyFormBehavior: {}
  },

  regions: {
    headerBar: '@ui.headerBar',
    breadcrumb: '@ui.breadcrumb',
    complianceRegistrationForm: '@ui.complianceRegistrationForm'
  },

  onBeforeShow: function() {
    this.showChildView(
      'breadcrumb',
      new BreadcrumbView({
        breadcrumbs: [
          {
            link: '#sec/compliance-registration-search',
            text: 'Home'
          },
          {
            text: 'View Compliance Registration'
          }
        ]
      })
    );

    this.complianceRegistrationForm = new SecCompRegFormView({
      model: this.model
    });

    this.showChildView('complianceRegistrationForm', this.complianceRegistrationForm);
  }
});
